import { cn } from "@/lib/utils";
import { formatNumber } from "@/lib/utils/formatters";
import { ReadShiftReportDepartmentEntry } from "@/types/shiftReportDepartmentEntry";
import { useTranslation } from "react-i18next";
import { hasEntryEnoughEmployees } from "../utils/hasEntryEnoughEmployees";
import ShiftReportEntryWarning from "./ShiftReportEntryWarning";

interface ShiftReportEntryProps {
  entry: ReadShiftReportDepartmentEntry;
}

const ShiftReportEntry = ({ entry }: ShiftReportEntryProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "p-2 transition-colors flex flex-col gap-2 border-b border-slate-200",
        {
          "text-orange-600": !hasEntryEnoughEmployees(entry),
        },
      )}
      data-testid="shift-report-department-entry"
    >
      <header className="flex flex-row justify-between text-sm items-center">
        <h3 className="font-medium truncate">{entry.department_name}</h3>
        <ShiftReportEntryWarning
          present={entry.present}
          ordered={entry.ordered}
          className={cn("text-xs", {
            "text-orange-600": !hasEntryEnoughEmployees(entry),
          })}
        />
      </header>
      <div className="flex items-center gap-4 text-xs">
        <div className="flex items-center gap-1.5">
          <span>{t("shiftReports.entry.ordered")}:</span>
          <span className="font-medium">{formatNumber(entry.ordered)}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <span>{t("shiftReports.entry.present")}:</span>
          <span>{formatNumber(entry.present)}</span>
        </div>
      </div>
    </div>
  );
};

export default ShiftReportEntry;
